import { useTranslation } from 'react-i18next';
import { Language } from '@mui/icons-material';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'da', label: 'Dansk', short: 'DA' },
    { code: 'en', label: 'English', short: 'EN' }
  ];

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
  };

  return (
    <div className="dropdown language-selector">
      <button
        className="btn language-selector-btn"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Select language"
      >
        <Language style={{ fontSize: '1.2rem' }} />
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {languages.map(lang => (
          <li key={lang.code}>
            <button
              className={`dropdown-item ${lang.code === i18n.language ? 'active' : ''}`}
              onClick={() => changeLanguage(lang.code)}
              type="button"
            >
              {lang.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSelector;
